import { ChevronRight } from 'lucide-react';
import { useState } from 'react';

interface JsonViewerProps {
  data: Record<string, unknown>;
  maxHeight?: number;
  label?: string;
}

export function JsonViewer({ data, maxHeight = 300, label = 'Metadata' }: JsonViewerProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-2 text-sm font-semibold text-foreground hover:text-primary"
      >
        <ChevronRight className={`h-4 w-4 transition-transform ${expanded ? 'rotate-90' : ''}`} />
        {label}
      </button>
      {expanded ? (
        <pre
          style={{ maxHeight }}
          className="overflow-auto rounded-md border border-border bg-muted/30 p-3 font-mono text-xs leading-relaxed"
        >
          {JSON.stringify(data, null, 2)}
        </pre>
      ) : null}
    </div>
  );
}
